export default {
  heading1: 'Новости',
  heading: 'Новости компании',
  readMore: 'Подробнее'
}